import React from "react";
import { Bell } from "lucide-react";
import { useTranslation } from "react-i18next";

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex w-screen items-center justify-center bg-purple-primary/10 dark:bg-purple-primary/40 h-dvh">
      <div className="text-center p-4 lg:p-8 bg-white shadow-md w-[90%] sm:w-1/2 lg:w-[30%] rounded-lg gap-3 flex flex-col">
        <div className="max-w-max mx-auto p-2 rounded-full bg-red-100 shadow-lg">
          <Bell className="text-red-500 w-10 h-10 " />
        </div>

        <h1 className="text-7xl font-bold text-red-500">404</h1>

        <h2 className="text-2xl font-semibold text-gray-800 ">
          {t("notFound")}
        </h2>
      </div>
    </div>
  );
};

export default NotFound;
